import { Injectable } from '@angular/core';
import { User } from '@src/app/_models/user/user';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    currentUser: User | null;

    checkUserISAdmin(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }

    checkUserISServiceAdmin(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin || user.rule?.is_service_admin) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }

    checkUserISAdministrative(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin || user.rule?.is_administrative) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }
}
